import Navigo from "navigo";
import { createMenu } from "./app.js";

const router = new Navigo("/", { hash: false });

export const appState = {
  currentPage: null,
  introCompleted: false,
};

async function loadView(viewPath) {
  try {
    const response = await fetch(viewPath);
    if (!response.ok) {
      throw new Error(`Erreur de chargement: ${viewPath}`);
    }
    const html = await response.text();
    return html;
  } catch (error) {
    console.error("Erreur lors du chargement de la vue:", error);
    return "<div>Erreur de chargement</div>";
  }
}

function setBodyPageClass(pageName) {
  document.body.className = document.body.className
    .split(" ")
    .filter((c) => !c.startsWith("page-"))
    .join(" ");
  document.body.classList.add(`page-${pageName}`);
}

async function renderPage(pageName, viewPath, onLoaded) {
  const app = document.getElementById("app");
  if (!app) {
    console.error("Element #app non trouvé");
    return;
  }

  const html = await loadView(viewPath);
  app.innerHTML = html;

  appState.currentPage = pageName;
  setBodyPageClass(pageName);

  if (onLoaded && typeof onLoaded === "function") {
    setTimeout(() => onLoaded(), 50);
  }
}

export function setupRouter(devPage = null) {
  router.on("/", async () => {
    await renderPage("intro", "/views/intro.html", () => {
      import("./intro.js").then((module) => {
        if (module.initIntro) {
          module.initIntro(router);
        }
      });
    });
  });

  router.on("/home", async () => {
    appState.introCompleted = true;

    await renderPage("home", "/views/home.html", () => {
      createMenu();
      import("./home.js").then((module) => {
        if (module.initMain) {
          module.initMain();
        }
      });
    });
  });

  router.on("/cart", async () => {
    appState.introCompleted = true;

    await renderPage("cart", "/views/cart.html", () => {
      createMenu();
      import("./cart.js").then((module) => {
        if (module.initCarte) {
          module.initCarte();
        }
      });
    });
  });

  router.notFound(async () => {
    await renderPage("404", "/views/404.html");
  });

  // Mode développement : charge directement la page spécifiée
  if (devPage) {
    console.log(`📍 Redirection vers /${devPage}`);
    router.navigate(`/${devPage}`);
    return;
  }

  // Mode normal : résout la route actuelle
  // Si la route n'existe pas, la page 404 sera affichée automatiquement
  router.resolve();
}

export default router;
